import { request, uploadFile } from "../base";
import type { SocialStudioTemplate } from "../social-drafts";

export type AdminSocialStudioTemplate = SocialStudioTemplate & {
	isActive: boolean;
	dateUpdated: string;
};

export const adminSocialStudioTemplatesApi = {
	async listTemplates(params?: {
		category?: string;
		includeInactive?: boolean;
	}) {
		const searchParams = new URLSearchParams();
		if (params?.category) searchParams.set("category", params.category);
		if (params?.includeInactive)
			searchParams.set("includeInactive", "true");
		const query = searchParams.toString();
		const url = `/api/admin/social-studio/templates${query ? `?${query}` : ""}`;
		return request<{ templates: AdminSocialStudioTemplate[] }>(url);
	},

	async createTemplate(
		file: File | null,
		fields: Record<string, string>,
	) {
		return uploadFile<{ template: AdminSocialStudioTemplate }>(
			"/api/admin/social-studio/templates",
			file,
			fields,
		);
	},

	async updateTemplate(
		id: string,
		file: File | null,
		fields: Record<string, string>,
	) {
		return uploadFile<{ template: AdminSocialStudioTemplate }>(
			`/api/admin/social-studio/templates/${id}`,
			file,
			fields,
			{ method: "PUT" },
		);
	},

	async deleteTemplate(id: string) {
		return request<{ ok: boolean }>(
			`/api/admin/social-studio/templates/${id}`,
			{
				method: "DELETE",
			},
		);
	},
};
